import { createXwiTheme } from '@xweather/theme'
import { components } from './components.ts'
import { paletteExtrasDark, paletteExtrasLight } from './palette.ts'
// biome-ignore lint/correctness/noPrivateImports: This is meant to be imported here
import { xwiPalette } from './xwiPalette.ts'

const alerts = {
	color: {
		alarm: xwiPalette.red[600],
		warning: xwiPalette.orange[500],
		info: xwiPalette.yellow[600],
		clear: { light: xwiPalette.grey[700], dark: xwiPalette.grey.A100 },
	},
	width: { alarm: 8, warning: 4, info: 2, clear: 2 },
	threatzone: {
		hail: { start: xwiPalette.violet[800], end: xwiPalette.violet[600], label: xwiPalette.violet[600], labelNow: xwiPalette.violet[900] },
		lightning: { start: xwiPalette.orange[800], end: xwiPalette.orange[600], labelNow: xwiPalette.orange[900] },
	},
}

declare module '@mui/material/styles' {
	interface Theme {
		alerts: typeof alerts
	}

	interface ThemeOptions {
		alerts: typeof alerts
	}
}

export const muiTheme = createXwiTheme({
	colorSchemes: { light: { palette: paletteExtrasLight }, dark: { palette: paletteExtrasDark } },
	alerts,
	components,
})
